import React, { useState } from 'react';
import { Loader2, ListTree } from 'lucide-react';
import { SyncChangesTable, labelsFor } from './SyncResultPanel';

export function SyncHistory({ log, remoteName, loadDetail, testid = 'sync-history' }) {
  const [open, setOpen] = useState(null);
  const [detail, setDetail] = useState(null);
  const [busy, setBusy] = useState('');
  const labels = labelsFor(remoteName);

  const view = async (id) => {
    if (open === id) { setOpen(null); setDetail(null); return; }
    setBusy(id);
    try { setDetail(await loadDetail(id)); setOpen(id); }
    catch { setDetail({ changes: [] }); setOpen(id); }
    setBusy('');
  };

  return (
    <div className="mt-3 text-xs space-y-1" data-testid={testid}>
      {log.length === 0 && <p style={{ color: 'var(--olive)' }}>No syncs recorded yet.</p>}
      {log.map((l) => (
        <div key={l.id} className="rounded border px-3 py-1.5" style={{ borderColor: 'rgba(0,0,0,0.08)', background: open === l.id ? 'rgba(0,0,0,0.02)' : 'white' }}>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span className="font-title">{new Date(l.at).toLocaleString()}</span>
            {Object.keys(labels).filter((k) => l.summary?.[k] > 0).map((k) => <span key={k}>{labels[k]}: <b>{l.summary[k]}</b></span>)}
            <span style={{ color: 'var(--olive)' }}>{l.summary?.unchanged ?? 0} unchanged</span>
            {l.errors?.length > 0 && <span style={{ color: '#8a1f11' }}>{l.errors.length} errors</span>}
            <button data-testid={`${testid}-view-${l.id}`} onClick={() => view(l.id)} className="ml-auto inline-flex items-center gap-1 px-2 py-0.5 rounded" style={{ color: 'var(--navy)', border: '1px solid rgba(0,0,0,0.15)' }}>
              {busy === l.id ? <Loader2 size={12} className="animate-spin" /> : <ListTree size={12} />} {open === l.id ? 'Hide changes' : 'View changes'}
            </button>
          </div>
          {open === l.id && detail && <SyncChangesTable changes={detail.changes} remoteName={remoteName} testid={`${testid}-changes`} />}
        </div>
      ))}
    </div>
  );
}
